<template>
  <b-form-group
    label="Hizmet Kodu"
    label-for="scode"
  >
    <validation-provider
      #default="{ errors }"
      name="Hizmet Kodu"
      :rules="autoCode? null : 'required'"
    >
      <b-input-group>
        <b-form-input
          id="scode"
          v-model="dataItem.scode"
          :placeholder="autoCode ? 'Otomatik oluşturulur' : 'Hizmet Kodu'"
          :disabled="autoCode"
          @input="checkCode"
        />
        <b-input-group-append
          v-b-tooltip.hover
          is-text
          title="Otomatik Oluştur"
        >
          <b-form-checkbox
            v-model="autoCode"
            @change="resetCode"
          />
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ServiceCode',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      autoCode: false,
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
  created() {
    localize('tr')
  },
  methods: {
    resetCode() {
      this.dataItem.scode = null
    },
    checkCode() {
      if (this.dataItem.scode) {
        this.$store.dispatch('services/checkCode', {
          scode: this.dataItem.scode,
          id: this.dataItem.id,
        })
          .then(res => {
            if (!res.status) {
              this.showToast({
                title: 'Geçersiz Kod!',
                icon: 'XCircleIcon',
                text: res.message,
                variant: 'danger',
              })
            }
          })
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'top-right',
      })
    },
  },
}
</script>
